import { render, staticRenderFns } from "./GroupLocation.vue?vue&type=template&id=323349fa&scoped=true"
import script from "./GroupLocation.vue?vue&type=script&lang=js"
export * from "./GroupLocation.vue?vue&type=script&lang=js"
import style0 from "./GroupLocation.vue?vue&type=style&index=0&id=323349fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323349fa",
  null
  
)

export default component.exports